module.exports = __webpack_public_path__ + "img/transactions.monthly.bc74c9cd.png";